import * as React from 'react'
import { PbrInput } from '../PbrInput/PbrInput'
import { WrappedFormUtils, ValidationRule } from 'antd/lib/form/Form';

export interface IPbrInputNumbersProps {
  title?: string
  name?: string
  value?: number | string
  rules?: ValidationRule[]
  formWrapper?: WrappedFormUtils
  onChange?: (value: string) => void
}

export const PbrInputNumbers: React.FC<IPbrInputNumbersProps> = ({
  title,
  name,
  value,
  rules,
  formWrapper,
  onChange
}) => {
  const onlyDigitsValidator = (rule: any, v: any, callback: any) => {
    const hasSpecialCharacters = /[^0-9]/g.exec(v);
    if (hasSpecialCharacters) {
      callback("Valor inválido, apenas números são permitidos.")
    } else {
      callback()
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onChange?.(e.target.value.replaceAll(/[^0-9]/g, "").trim())

  return (
    <PbrInput
      type="tel"
      name={name}
      value={value}
      style={{ color: "black" }}
      formItemProps={{ label: title }}
      formWrapper={formWrapper}
      rules={[...rules, { validator: onlyDigitsValidator }]}
      onChange={handleChange}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/common/PbrInputNumbers/PbrInputNumbers.tsx